import { hudViewport } from './hud-viewport';
import { dustHudLayout } from './hud-viewport';

/** World-space target for break-loot fly animation (right-panel dust HUD). */
export function dustHudWorldTarget(scrollX: number) {
  const layout = dustHudLayout();
  const x =
    scrollX + hudViewport.x + layout.dustRightX - layout.dustIconSize * 0.5 - layout.dustGap;
  const y = hudViewport.y + layout.rowY;
  return { x, y };
}
